import React from 'react';
import style from '../../../PaperworkList/PaperworkList.module.css';
import s from '../CashOrdersList.module.css';

type Props = {
	titles: string[];
};

const CashierTableHead: React.FC<Props> = ({titles}) => {
	return (
		<div className={`${style.tableRow} ${s.tableRow}`}>
			{titles.map((title, index) => (
				<div key={title + index} className={style.tableColumn}>
					{title}
				</div>
			))}
		</div>
	);
};

export default CashierTableHead;
